<div class="col d-flex flex-row align-items-center min-height mx-3 border-bottom">
    <h1 class="page-title">Current Contracts</h1>
    <a class="btn btn-light ms-auto" (click)="addCurrentContract()">
        <span [hidden]="!loading">
            <div class="spinner-border spinner-border-sm me-1" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </span>
        <i class="fas fa-plus"></i>
        Input Current Contract
    </a>
</div>

<div class="table-responsive">
  <table class="table mb-0">
    <thead class="border-bottom">
      <tr>
        <th>Location</th>
        <th>Supplier</th>
        <th>Delivery Point</th>
        <th>Percentage Awarded</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td *ngIf="!currentOffers.length" colspan="5">
          <p class="small text-center my-5">
            No current contracts available. Begin by inputting a <a (click)="addCurrentContract()" href="javascript:void()">
              <span [hidden]="!loading">
                <div class="spinner-border spinner-border-sm me-1" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </span> Current Contract</a>
          </p>
        </td>
      </tr>
      <tr *ngFor="let offer of currentOffers; let index = index;">
        <td>
          <span>{{offer.location ? offer.location.getStandardLabel() : 'Not specified'}}</span>
        </td>
        <td>
          {{offer.supplier ? offer.supplier.name : 'Not specified'}}
        </td>
        <td>
          {{offer.fuelPreference ? offer.fuelPreference.getLabel() : ''}}
        </td>
        <td>
          <span *ngIf="offer.awardedPercent">
            {{offer.awardedPercent}}%
          </span>
        </td>
        <td class="text-end">
          <a class="pointer" (click)="editCurrentContract(offer)">Edit</a>
          <a [ngbPopover]="deleteContract" placement="left" [popoverTitle]="" [autoClose]="true" #p="ngbPopover"
            alt="Remove supplier" class="pointer ms-3">
            Delete
          </a>
          <ng-template #deleteContract>
            <p class="mb-2"><strong>{{offer.location ? offer.location.name : 'Contract'}}</strong>
              will be removed from the from this tender.
            </p>
            <div class="row">
              <div class="col pe-1">
                <button (click)="p.close()" class="btn w-100 btn-light">
                  Cancel
                </button>
              </div>
              <div class="col ps-1">
                <button (click)="deleteCurrentContract(offer)" class="btn w-100 btn-danger">
                  Confirm
                </button>
              </div>
            </div>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>


